import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { UserMenuComponent } from '../components/UserMenu';
import { getPrettyName } from '../helpers/getPrettyName';

const mapStateToProps = (state) => {
  const user = selectors.userAccount.properties(state).data || {};
  return {
    user,
    userName: getPrettyName(user),
  };
};

export const UserMenu = connect(mapStateToProps)(UserMenuComponent);
